import { truncate } from 'es-toolkit/compat';
import React from 'react';

import { SecondaryButton } from '@components/Button/variants';
import LinkCopy from '@components/LinkCopy';
import { forum_post_path } from '@routes';
import { ForumPost } from '@utils/backend-api/forumPosts';
import { stripHtml } from '@utils/formatting';

import styles from './styles.module.scss';

// React version of app/views/articles/components/_share_modal.html.erb
// TODO: Add share url params, see ArticlesController#set_up_sharing
export default function ShareModalContent({
  forumPost,
  title = 'Share forum post',
  subtitle,
  iconSrc,
  onDownloadScreenshot,
  copyLinkOnly = false,
}: {
  forumPost: ForumPost;
  title?: string;
  subtitle?: string;
  iconSrc?: string;
  onDownloadScreenshot?: (darkMode?: boolean) => void;
  copyLinkOnly?: boolean;
}) {
  const snippet = stripHtml(forumPost.comment.snippet);

  const url = `${window.location.origin}${forum_post_path(forumPost.id)}`;
  const text = `${forumPost.title.trim()}

${snippet}`;

  const tweet = `${truncate(text, { length: 240 })}

${url}`;

  return (
    <div className={styles.shareModalContent}>
      {!!iconSrc && <img src={iconSrc} className={styles.shareIcon} />}
      <div className={styles.shareTitle}>{title}</div>
      {!!subtitle && <div className="mb-24 text-grayscale-gray">{subtitle}</div>}
      <LinkCopy clipboardLink={url} customClass={copyLinkOnly ? 'mb-48' : 'mb-24'} />
      {!copyLinkOnly && (
        <>
          <LinkCopy
            clipboardLink={tweet}
            buttonText="Copy tweet"
            customClass="mb-48"
            successButtonText="Tweet copied!"
            asTextArea
          />
          {!!onDownloadScreenshot && (
            <div className="mb-24 flex flex-col items-center justify-center gap-16 sm:flex-row">
              <SecondaryButton as="button" size="small" onClick={() => onDownloadScreenshot()}>
                Download light mode
              </SecondaryButton>
              <SecondaryButton as="button" size="small" onClick={() => onDownloadScreenshot(true)}>
                Download dark mode
              </SecondaryButton>
            </div>
          )}
        </>
      )}
    </div>
  );
}
